import { render } from "./UserProfileCard.vue?vue&type=template&id=8d78efdc"
import script from "./UserProfileCard.vue?vue&type=script&lang=js"
export * from "./UserProfileCard.vue?vue&type=script&lang=js"
script.render = render

export default script